import { render } from "./GoogleLoginPage.vue?vue&type=template&id=de99e4e8"
import script from "./GoogleLoginPage.vue?vue&type=script&lang=js"
export * from "./GoogleLoginPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__